import "./style/fabric.scss";
import { useEffect, useState } from "react";
import { axios } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../stores/auth";

const DetailStyleOptionsPage = (props) => {
  const [styleOption, setStyleOption] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const dataLogin = useSelector(loginData);

  useEffect(() => {
    const getStyleOption = async () => {
      if (!props.data || !props.data._id) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const res = await axios.get(`/v1/style_options/${props.data._id}`, {
          headers: { Authorization: `Bearer ${dataLogin.data.token}` },
        });

        if (res.data && res.data.data) {
          setStyleOption(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching style option detail:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getStyleOption();
  }, [props.data, dataLogin.data.token]);

  if (isLoading) {
    return <div className="detail-fabric">Loading style option details...</div>;
  }

  if (!styleOption) {
    return <div className="detail-fabric">Style option not found.</div>;
  }

  return (
    <div className="detail-fabric">
      <div className="detail-field">
        <div className="detail-key">Name Options</div>
        <div className="detail-value">{styleOption.name || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Part of</div>
        <div className="detail-value">{styleOption.partId?.name || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Type Parts</div>
        <div className="detail-value">{styleOption.partId?.type || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Front Name</div>
        <div className="detail-value">{styleOption.frontName || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Back Name</div>
        <div className="detail-value">{styleOption.backName || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Folded Name</div>
        <div className="detail-value">{styleOption.foldedName || "-"}</div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Fabrics</div>
        <div className="detail-value" style={{ flexWrap: "wrap", gap: "6px" }}>
          {styleOption.arrayOfFabric && styleOption.arrayOfFabric.length > 0 ? (
            styleOption.arrayOfFabric.map((fabric, idx) => (
              <span
                key={fabric._id || idx}
                style={{
                  padding: "4px 8px",
                  borderRadius: "4px",
                  backgroundColor: "#F0F0F0",
                  fontSize: "12px",
                  marginRight: "6px",
                  marginBottom: "6px",
                  display: "inline-block",
                }}
              >
                {fabric.fabric_name || fabric}
              </span>
            ))
          ) : (
            "-"
          )}
        </div>
      </div>
      <div className="detail-field">
        <div className="detail-key">Icon Path</div>
        <div className="detail-value" style={{ flexDirection: "column", alignItems: "flex-start" }}>
          {styleOption.icon ? (
            <>
              <img
                src={styleOption.icon}
                alt={styleOption.name}
                style={{
                  height: "80px",
                  width: "80px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  marginBottom: "8px",
                  border: "1px solid #ddd"
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
              <span style={{ fontSize: "12px", color: "#666", wordBreak: "break-all" }}>
                {styleOption.icon}
              </span>
            </>
          ) : (
            "-"
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailStyleOptionsPage;